<template>
  <a-modal
    title="编辑处方审核"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item v-show="false"><a-input v-decorator="['id']" /></a-form-item>
        <a-form-item
          label="处方编号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入处方编号" v-decorator="['recipeNo', {rules: [{required: true, message: '请输入处方编号！'}]}]" />
        </a-form-item>
        <a-form-item
          label="服务类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入服务类型" v-decorator="['businessType', {rules: [{required: true, message: '请输入服务类型！'}]}]" />
        </a-form-item>
        <a-form-item
          label="姓名"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入姓名" v-decorator="['name', {rules: [{required: true, message: '请输入姓名！'}]}]" />
        </a-form-item>
        <a-form-item
          label="性别"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入性别" v-decorator="['sex', {rules: [{required: true, message: '请输入性别！'}]}]" />
        </a-form-item>
        <a-form-item
          label="年龄"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入年龄" v-decorator="['age', {rules: [{required: true, message: '请输入年龄！'}]}]" />
        </a-form-item>
        <a-form-item
          label="科室编码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入科室编码" v-decorator="['departmentId', {rules: [{required: true, message: '请输入科室编码！'}]}]" />
        </a-form-item>
        <a-form-item
          label="科室"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入科室" v-decorator="['department', {rules: [{required: true, message: '请输入科室！'}]}]" />
        </a-form-item>
        <a-form-item
          label="医生编码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入医生编码" v-decorator="['doctorId', {rules: [{required: true, message: '请输入医生编码！'}]}]" />
        </a-form-item>
        <a-form-item
          label="医生姓名"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入医生姓名" v-decorator="['doctorName', {rules: [{required: true, message: '请输入医生姓名！'}]}]" />
        </a-form-item>
        <a-form-item
          label="医生职称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入医生职称" v-decorator="['doctorTitle', {rules: [{required: true, message: '请输入医生职称！'}]}]" />
        </a-form-item>
        <a-form-item
          label="状态"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入状态" v-decorator="['status', {rules: [{required: true, message: '请输入状态！'}]}]" />
        </a-form-item>
        <a-form-item
          label="开方时间"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-date-picker style="width: 100%" placeholder="请选择开方时间" v-decorator="['ctstamp',{rules: [{ required: true, message: '请选择开方时间！' }]}]" @change="onChangectstamp"/>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import moment from 'moment'
// import { recipeEdit } from '@/api/modular/interhospital/statistics/statisticsMange'
  export default {
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        ctstampDateString: '',
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this)
      }
    },
    methods: {
      moment,
      // 初始化方法
      edit (record) {
        this.visible = true
        setTimeout(() => {
          this.form.setFieldsValue(
            {
              id: record.id,
              recipeNo: record.recipeNo,
              businessType: record.businessType,
              name: record.name,
              sex: record.sex,
              age: record.age,
              departmentId: record.departmentId,
              department: record.department,
              doctorId: record.doctorId,
              doctorName: record.doctorName,
              doctorTitle: record.doctorTitle,
              status: record.status
            }
          )
        }, 100)
        // 时间单独处理
        if (record.ctstamp != null) {
            this.form.getFieldDecorator('ctstamp', { initialValue: moment(record.ctstamp, 'YYYY-MM-DD') })
        }
        this.ctstampDateString = moment(record.ctstamp).format('YYYY-MM-DD')
      },
      handleSubmit () {
        const { form: { validateFields } } = this
        this.confirmLoading = true
        validateFields((errors, values) => {
          if (!errors) {
            for (const key in values) {
              if (typeof (values[key]) === 'object') {
                values[key] = JSON.stringify(values[key])
              }
            }
            values.ctstamp = this.ctstampDateString
            recipeEdit(values).then((res) => {
              if (res.success) {
                this.$message.success('编辑成功')
                this.confirmLoading = false
                this.$emit('ok', values)
                this.handleCancel()
              } else {
                this.$message.error('编辑失败')//  + res.message
              }
            }).finally((res) => {
              this.confirmLoading = false
            })
          } else {
            this.confirmLoading = false
          }
        })
      },
      onChangectstamp(date, dateString) {
        this.ctstampDateString = dateString
      },
      handleCancel () {
        this.form.resetFields()
        this.visible = false
      }
    }
  }
</script>
